import {forwardRef} from "react";
import {ButtonGroup} from "@mui/material";
import {Box} from "@mui/system";

export const ButtonGroupTabBar = forwardRef(({children, activeTab}, ref) => {
    return <Box ref={ref} sx={{display: 'inline-flex', width: 'fit-content'}}><ButtonGroup
        variant="outlined"
        aria-label="button group"
        sx={{
            height: "48px",
            flexShrink: 0,
            "& button": {
                fontWeight: 500,
                flexShrink: 0,
                whiteSpace: "nowrap",
                border: (theme) => `${theme.palette.primary.main} solid 1px`,
                color: (theme) => theme.palette.text.main,
                textTransform: "none",
                padding: "12px",
                gap: "8px",
                "& .MuiSvgIcon-root": {display: "none"},
                [`&[tabindex='${activeTab}']`]: {
                    backgroundColor: (theme) => theme.palette.primary.light,
                    "& .MuiSvgIcon-root": {
                        display: "inline-block",
                        width: "17px"
                    }
                },
                '&:first-of-type': {
                    borderTopLeftRadius: "100px",
                    borderBottomLeftRadius: "100px"
                },
                '&:last-of-type': {
                    borderTopRightRadius: "100px",
                    borderBottomRightRadius: "100px"
                }
            },
            "& button[data-tab-label='alert']": {
                backgroundColor: (theme) => theme.palette.error.main,
                borderColor: (theme) => theme.palette.error.main,
                color: (theme) => theme.palette.text.main,
                "&:hover": {
                    backgroundColor: (theme) => theme.palette.error.light,
                    borderColor: (theme) => theme.palette.error.main,
                },
            },
            "& button[data-tab-label='alert'] .MuiSvgIcon-root": {
                color: (theme) => theme.palette.text.main,
            },
            [`& button[data-tab-label='alert'][tabindex='${activeTab}']`]: {
                backgroundColor: (theme) => theme.palette.error.main,
                borderColor: (theme) => theme.palette.error.main,
                color: (theme) => theme.palette.text.main,
                "& .MuiSvgIcon-root": {
                    display: "inline-block",
                    width: "17px",
                    color: (theme) => theme.palette.text.main,
                },
            },
        }}>
        {children}
    </ButtonGroup></Box>
})